export function getSessionData(itemKey: string): string | null {
    return window.sessionStorage.getItem(itemKey);
}

export function setSessionData(itemKey: string, data: any): void {
    const stringData = typeof data === 'object' ? JSON.stringify(data) : data;
    window.sessionStorage.setItem(itemKey, stringData);
}
